module.exports = "<rzslider rz-slider-model=rangeSliderCtrl.sliderMinimum rz-slider-high=rangeSliderCtrl.sliderMaximum rz-slider-options=rangeSliderCtrl.options></rzslider>";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/range-slider/range-slider.tmpl.html
// module id = 527
// module chunks = 0